import type { SubscriptionPlan } from '@/lib/subscription'
import type { IconToken } from './icon-map'

export interface NavItemConfig {
  title: string
  href: string
  group?: 'operations' | 'setup' | 'business' | 'admin'
  icon?: IconToken
  requiresPlan?: SubscriptionPlan
  requiresRole?: 'admin'
}

export const NAV_ITEMS: NavItemConfig[] = [
  {
    title: 'Today',
    href: '/',
    group: 'operations',
    icon: 'home',
  },
  {
    title: 'Appointments',
    href: '/appointments',
    group: 'operations',
    icon: 'calendar',
  },
  {
    title: 'Services',
    href: '/services',
    group: 'setup',
    icon: 'wrench',
  },
  {
    title: 'Availability',
    href: '/availability',
    group: 'setup',
    icon: 'calendar',
  },
  {
    title: 'Locations',
    href: '/locations',
    group: 'setup',
    icon: 'map-pin',
  },
  {
    title: 'Service Area',
    href: '/service-area',
    group: 'setup',
    icon: 'map',
  },
  {
    title: 'Profile',
    href: '/business',
    group: 'business',
    icon: 'briefcase',
  },
  {
    title: 'Booking Info',
    href: '/booking-info',
    group: 'setup',
    icon: 'file-text',
  },
  {
    title: 'Appearance',
    href: '/appearance',
    group: 'setup',
    icon: 'palette',
  },
  {
    title: 'Integrations',
    href: '/integrations',
    group: 'business',
    icon: 'integrations',
  },
  {
    title: 'Billing',
    href: '/billing',
    group: 'business',
    icon: 'credit-card',
  },
  {
    title: 'Admin',
    href: '/admin',
    group: 'admin',
    icon: 'shield',
    requiresRole: 'admin',
  },
  {
    title: 'Users',
    href: '/admin/users',
    group: 'admin',
    icon: 'users',
    requiresRole: 'admin',
  },
  {
    title: 'Analytics',
    href: '/admin/analytics',
    group: 'admin',
    icon: 'pie-chart',
    requiresRole: 'admin',
  },
  {
    title: 'Emails',
    href: '/admin/emails',
    group: 'admin',
    icon: 'message',
    requiresRole: 'admin',
  },
  {
    title: 'Support',
    href: '/admin/support',
    group: 'admin',
    icon: 'message',
    requiresRole: 'admin',
  },
  {
    title: 'Content',
    href: '/admin/content',
    group: 'admin',
    icon: 'frame',
    requiresRole: 'admin',
  },
  {
    title: 'Audit Logs',
    href: '/admin/audit',
    group: 'admin',
    icon: 'activity',
    requiresRole: 'admin',
  },
]
